module.exports = __webpack_public_path__ + "img/mes-capture-workorderview.02e00d25.png";